//

import SCPluginDescription from "@/components/SmartContractDesigner/sidebar/PluginDescription/SCPluginDescription.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

import DeleteDialogue from "@/components/Admin/Dialogs/DeleteDialog.vue";
import SCFunctionCanvasElements from "@/components/SmartContractDesigner/SCFunctionsHandler/SCFunctionCanvasElements/SCFunctionCanvasElements.vue";
import { uid } from "quasar";
import SCFunctionCodePreview from "@/components/SmartContractDesigner/SCFunctionCodePreview/SCFunctionCodePreview.vue";
import { DiagramValidator } from "@/assets/js/DiagramValidator/diagram-validator.js";
import SCEditAddFunction from "../../SCFunctionsHandler/SCEditAddFunction/SCEditAddFunction.vue";
import NoFunctionsPage from "../../SCFunctionsHandler/SCNoFunctionsDefined/NoFunctionsPage.vue";
import SCFunctionVariables from "../../SCFunctionsHandler/SCFunctionVariables/SCFunctionVariables.vue";
import SCFunctionDetails from "../../SCFunctionsHandler/SCFunctionDetails/SCFunctionDetails.vue";

export default {
    name: "SmartContractSidebarHandler",
    components: {
        SCPluginDescription,
        NoFunctionsPage,
        SCFunctionDetails,
        SCEditAddFunction,
        SCFunctionCanvasElements,
        SCFunctionVariables,
        DeleteDialogue,
        SCFunctionCodePreview
    },
    props: {
        diagramRef: Object,
        readonly: Boolean
    },
    data() {
        return {
            collapsedFunctionUUID: null,
            selectedTab: "details",
            tabs: ["details", "params", "returns"],
            displayFabricModal: false,
            displayCodePreview: false,
            duplicateParams: false,
            nullVarType: false,
            inEditOrAddFunc: null,
            inCreateFunc: null,
            showDeleteDlg: false,
            deletingIndex: null,
            selectedFunction: null,
            lastInitializedDiagramDataFor: null,
            functionError: {
                noNameError: false,
                duplicateError: false
            }
        };
    },
    computed: {
        ...mapGetters("smartContractDesigner", [
            "selectedPluginComponent",
            "selectedPluginData",
            "inEditFunction",
            "applicationFunctions",
            "applicationFunctionsAsDDL",
            "smartContractValidationModel",
            "getDiagramError",
            "functionsSignatures"
        ]),
        ...mapGetters("apps", ["currentApp"])
    },
    watch: {
        inEditFunction(val) {
            this.selectedFunction = val ? val.id : null;
        },
        selectedFunction(val) {
            const self = this;
            if (
                this.inEditFunction
        && this.inEditFunction.id === val
        // this still might be needed
        // && this.lastInitializedDiagramDataFor === val
            ) {
                this.selectedFunction = this.inEditFunction.id;
                return;
            }
            self.$store.commit(
                "smartContractDesigner/setInEditFunction",
                val ? self.applicationFunctions.find(func => func.id === val) : null
            );
            self.$emit("pluginSelected", null);
            if (self.inEditFunction) {
                self.$store
                    .dispatch(
                        "smartContractDesigner/getFunctionData",
                        self.inEditFunction.id
                    )
                    .then((rsp) => {
                        if (rsp && rsp.diagram) {
                            self.lastInitializedDiagramDataFor = self.inEditFunction
                                ? self.inEditFunction.id
                                : null;
                            self.diagramRef.changeDataSet(rsp.diagram);
                        }
                    });
            }
        }
    },
    methods: {
        ...mapMutations("smartContractDesigner", [
            "setInEditFunction",
            "deleteFunction",
            "addFunction",
            "updateFunction"
        ]),
        ...mapActions("smartContractDesigner", [
            "getFunctionsForApp",
            "createSmartContractValidationModel",
            "getNewFunctionModel",
            "deleteApplicationFunction"
        ]),
        selectPlugin(e) {
            this.$emit("pluginSelected", e);
        },
        selectedFunctionChanged(e) {
            // run validations on current function
            if (this.inEditFunction && this.inEditFunction.id !== e) {
                const validator = new DiagramValidator(this.smartContractValidationModel);
                const result = validator.validate(this.diagramRef.getDiagramData());
                if (result && !result.valid && result.errors.length > 0) {
                    result.errors.forEach(error => {
                        console.log(error);
                    });
                    this.$store.commit("smartContractDesigner/setDiagramError", true);
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("smartContract.main.diagramError")
                    });
                    return;
                }
                this.$store.commit("smartContractDesigner/setDiagramError", false);
            }
            if (this.selectedFunction && this.selectedFunction !== e) {
                this.$store.commit(
                    "smartContractDesigner/setIndexesForCurrentFunction",
                    this.selectedFunction
                );
            }
            this.selectedFunction = e;
        },
        deleteFunctionResponse(val) {
            this.showDeleteDlg = false;
            const self = this;
            if (val.response) {
                if (
                    this.applicationFunctions[this.deletingIndex].id
          === this.inEditFunction.id
                ) {
                    this.$store.commit("smartContractDesigner/setInEditFunction", null);
                }
                if (this.applicationFunctions[this.deletingIndex].newlyAdded) {
                    this.deleteFunction(this.applicationFunctions[this.deletingIndex].id);
                    this.deletingIndex = null;
                    return;
                }
                self
                    .deleteApplicationFunction(
                        self.applicationFunctions[self.deletingIndex].id
                    )
                    .then(data => {
                        if (!self.inEditFunction) {
                            self.getNewFunctionModel().then((data) => {
                                self.diagramRef.changeDataSet(data.diagramData);
                            });
                        }
                    });
            }
            this.deletingIndex = null;
        },

        checkDuplicates(functionName) {
            const duplicateName = this.functionsSignatures.some(element => {
                const nameFunctionEdit = this.inEditOrAddFunc ? this.inEditOrAddFunc.name : null;
                return (element.name === functionName && element.name !== nameFunctionEdit);
            });
            this.$root.$emit("duplicate-name", duplicateName);
            return duplicateName;
        },

        checkParams(value) {
            let paramsArray = [];
            paramsArray = value.inParameters.concat(value.outParameters);
            if (paramsArray && paramsArray.length > 0) {
                for (let i = 0; i < paramsArray.length; i++) {
                    let counts = 0;
                    paramsArray.forEach(element => {
                        if (element.name === paramsArray[i].name) {
                            counts++;
                        }
                    });
                    if (counts > 1) {
                        return true;
                    }
                }
            }
        },

        checkParamsType(value) {
            const varArray = value.inParameters.concat(value.outParameters);
            this.nullVarType = false;

            if (varArray && varArray.length > 0) {
                for (let i = 0; i < varArray.length; i++) {
                    if (!varArray[i].type) {
                        this.nullVarType = true;
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("smartContract.manageFunctions.varTypeNull")
                        });
                        break;
                    }
                }
            }
        },

        actionsDlg($event) {
            if ($event.detailed === "action_save") {
                const data = this.$refs.editAddHandler.getMutableData();
                const validatePattern = new RegExp("^[a-zA-Z]*[a-zA-Z_][a-zA-Z0-9_]*$");
                this.functionError.noNameError = false;
                this.$root.$emit("function-error", this.functionError);

                if (!this.checkDuplicates(data.name)) {
                    if (data.name && validatePattern.test(data.name)) {
                        if (!data.id) {
                            if (!this.checkParams(data)) {
                                this.checkParamsType(data);
                                if (!this.nullVarType) {
                                    data.id = uid();
                                    [...data.inParameters, ...data.outParameters].forEach(param => {
                                        if (!param.functionId) {
                                            param.functionId = data.id;
                                        }
                                    });
                                    this.$store.commit("smartContractDesigner/addFunction", data);
                                }
                                if (!this.inEditFunction) {
                                    this.$store.commit(
                                        "smartContractDesigner/setInEditFunction",
                                        data
                                    );
                                }
                                this.duplicateParams = false;
                            } else {
                                this.$toast.showNotify({
                                    type: "error",
                                    message: this.$t("smartContract.manageFunctions.duplicateParams")
                                });
                                this.duplicateParams = true;
                            }
                        } else if (!this.checkParams(data)) {
                            this.checkParamsType(data);
                            if (!this.nullVarType) {
                                this.$store.commit("smartContractDesigner/updateFunction", data);
                                this.duplicateParams = false;
                            }
                        } else {
                            this.$toast.showNotify({
                                type: "error",
                                message: this.$t("smartContract.manageFunctions.duplicateParams")
                            });
                            this.duplicateParams = true;
                        }
                        if (data.newlyAdded) {
                            this.selectedFunction = data.id;
                        }

                        if (!this.duplicateParams && !this.nullVarType) {
                            this.displayFabricModal = this.displayCodePreview = false;
                            this.inEditOrAddFunc = null;
                            this.inCreateFunc = null;
                            this.functionError.noNameError = false;
                            this.$root.$emit("function-error", this.functionError);
                        }
                    }
                } else {
                    this.functionError.noNameError = true;
                    this.$root.$emit("function-error", this.functionError);
                }
            } else if (!this.duplicateParams) {
                this.displayFabricModal = this.displayCodePreview = false;
                this.inEditOrAddFunc = null;
                this.inCreateFunc = null;
                this.functionError.noNameError = false;
                this.$root.$emit("function-error", this.functionError);
            }
        },
        previewFunctionCode() {
            if (!this.inEditFunction) {
                alert("Please select a function first!");
                return;
            }
            this.displayFabricModal = this.displayCodePreview = true;
        },
        requestDeleteDialog() {
            this.showDeleteDlg = true;
            const self = this;
            this.deletingIndex = this.applicationFunctions.findIndex((func) => func.id === self.selectedFunction);
        },
        editFunction() {
            const self = this;
            const index = this.applicationFunctions.findIndex((func) => func.id === self.selectedFunction);
            this.inEditOrAddFunc = {

                ...this.applicationFunctions[index]
            };
            this.displayFabricModal = true;
        },
        collapsedItem(obj, index) {
            this.collapsedFunctionUUID = obj.id;
            this.selectedTab = this.tabs[0];
            event.preventDefault();
            this.$store.commit(
                "smartContractDesigner/setInEditFunction",
                this.applicationFunctions[index]
            );
            this.$emit("closeDialog");
        },
        displayCodePreviewTrigger(index) {},
        addFunction() {
            this.getNewFunctionModel(this.currentApp).then(data => {
                data.index = this.applicationFunctions.length;
                // this.inEditOrAddFunc = data;
                this.inCreateFunc = data;
                this.displayFabricModal = true;
            });
        }
    },
    mounted() {
        this.createSmartContractValidationModel();
    }
};
